import { render, staticRenderFns } from "./vTextarea.vue?vue&type=template&id=5d6e1fcc"
import script from "./vTextarea.vue?vue&type=script&lang=js"
export * from "./vTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports